import styled from 'styled-components';
import { Spacing8, Spacing40 } from 'autogen/design-tokens/tokens';
import type { GlobalUspItemModel } from 'autogen/swagger/all';
import Icon from 'components/Icon';
import USP from './USP';

const StyledIcon = styled(Icon)`
    margin-right: ${Spacing8};
`;

const List = styled.ul`
    display: flex;
    align-items: center;
    list-style: none;
    margin: 0;
    padding: 0;
`;

const ListItem = styled.li`
    display: flex;
    align-items: center;

    & + & {
        margin-left: ${Spacing40};
    }
`;

export default function DesktopUSPHeader({ usps }: { usps: GlobalUspItemModel[] }) {
    return (
        <List>
            {usps.map((usp, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <ListItem key={i}>
                    <StyledIcon type="Checkmark" size={16} aria-hidden />

                    <USP {...usp} />
                </ListItem>
            ))}
        </List>
    );
}
